import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AiChatMessage } from '../models/ai-message.model';

@Injectable()
export class AiChatService {
  private readonly _messagesSubject = new BehaviorSubject<AiChatMessage[]>([this.initialMessage()]);
  private _chatId: string;
  
  readonly messages$ = this._messagesSubject.asObservable();

  reset() {
    this.setChatId(null);
    this._messagesSubject.next([this.initialMessage()]);
  }

  addMessage(message: AiChatMessage | AiChatMessage[]) {
    this._messagesSubject.next(this._messagesSubject.value.concat(message));
  }

  clearMessages() {
    this._messagesSubject.next([]);
  }

  getMessages(): AiChatMessage[] {
    return this._messagesSubject.value;
  }

  getChatId(): string {
    return this._chatId;
  }

  setChatId(chatId: string) {
    this._chatId = chatId;
  }

  private initialMessage(): AiChatMessage {
    return {
      id: Date.now().toString(),
      content: 'ai_greetings',
      translate: true,
      role: 'assistant',
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/services/ai-chat.service.ts